@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.tray + .tray {
  margin-top: 16px;
}

.heading {
  color: var(--override-menu-section-header-color, var(--menu-section-header-color));
  padding: 8px 8px 4px 8px;
  display: block;
  margin: 0;

  .tray & {
    padding: 0;
    align-self: stretch;
  }
}

.group {
  padding: 0;
  list-style: 'none';
  display: flex;
  flex-direction: column;
  gap: 2px;

  .tray & {
    gap: 0;
  }
}
